import { Alert, NavigationLink } from '@ui/themed';
import { t } from 'i18next';
import { useHandlers } from '../../../../context/page-context';
import { CUSTOMER_GROUP_CREATE_METHOD_PATH_IDS } from '../../create-method';
import { useCustomerGroupsQuickSetupForm } from '../../hooks/use-customer-groups-quick-setup-form';
import { buildQuickSetupAdvancedQuery } from '../../quick-setup-to-builder';

export function SwitchToAdvancedAlert() {
  const { navigationHandler } = useHandlers();
  const form = useCustomerGroupsQuickSetupForm();

  return (
    <Alert
      title={t('features:customer_group.pages.customer_groups_quick_setup_page.alert.title')}
      headingLevel="h2"
    >
      <div className="flex flex-col items-start gap-2">
        {t('features:customer_group.pages.customer_groups_quick_setup_page.alert.message')}
        <NavigationLink
          onClick={() =>
            navigationHandler.navigateById(CUSTOMER_GROUP_CREATE_METHOD_PATH_IDS.advanced, {
              query: buildQuickSetupAdvancedQuery(form.state.values),
            })
          }
        >
          {t(
            'features:customer_group.pages.customer_groups_quick_setup_page.alert.switch_to_advanced',
          )}
        </NavigationLink>
      </div>
    </Alert>
  );
}
